import { useContext } from 'react';
import { UserConfigContext } from '../contexts/StoreContext/UserConfigContext';

export function useUserConfigContext() {
  const ctx = useContext(UserConfigContext);
  if (!ctx) throw new Error(`useAppContext must be used inside UserConfigContextProvider`);
  return ctx;
}
